import { createClient } from "@/lib/supabase/client";
import type { BlogPostComment } from "@/lib/supabase/types";

export async function addComment(
	userId: string,
	postId: string,
	comment: string,
	parentCommentId?: string,
) {
	const supabase = createClient();
	const { data, error } = await supabase
		.from("blog_post_comments")
		.insert({
			user_id: userId,
			post_id: postId,
			comment: comment,
			parent_comment_id: parentCommentId,
		})
		.select()
		.single()
		.overrideTypes<BlogPostComment>();
	return { data, error };
}

export async function editComment(commentId: string, comment: string) {
	const supabase = createClient();
	const { data, error } = await supabase
		.from("blog_post_comments")
		.update({
			comment: comment,
		})
		.eq("id", commentId)
		.select()
		.single()
		.overrideTypes<BlogPostComment>();
	return { data, error };
}

export async function deleteComment(userId: string, commentId: string) {
	const supabase = createClient();
	const { data, error } = await supabase
		.from("blog_post_comments")
		.delete()
		.eq("id", commentId)
		.eq("user_id", userId);
	return { data, error };
}

export async function getUserComments(userId: string) {
	const supabase = createClient();
	const { data, error } = await supabase
		.from("blog_post_comments")
		.select("*")
		.eq("user_id", userId)
		.overrideTypes<BlogPostComment[]>();
	return { data, error };
}
